import moment from 'moment';

export function dateTimeToDateString(value: any) {
  if (value) {
    return moment(value).format('DD.MM.YYYY');
  }
}

export function dateTimeToDateWithTimeString(value: any) {
  if (value) {
    return moment(value).format('DD.MM.YYYY HH:mm');
  }
}
